import styled from 'styled-components';
import { Cancel } from '@mui/icons-material';

import DialogModal from '../../../../../components/DialogModal';
import { SectionLabel, RowList, Row } from '../SidebarFilter/styles';
import colors from '../../../../../styles/colors';

const FullPostContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(95vh - 40px);
  padding: 0 20px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const AnnouncementContainer = styled.div`
  width: 100%;
  display: flex;
  flex-shrink: 0;
`;

const PodFilterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 100%;
  padding: 8px 0;
  overflow-x: auto;
  gap: 8px;
`;

const CommentsRow = styled.div`
  display: flex;
  align-items: stretch;
  flex: 1;
  min-height: 0;
`;

const CommunityRail = styled.div`
  width: 200px;
  flex-shrink: 0;
  padding: 12px 16px 12px 0;
  border-right: 1px solid ${colors.shades.gamma13};
  overflow-y: auto;
`;

const CommentsColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  /* A flex item never shrinks below its content's width by default; this keeps the column inside the dialog. */
  min-width: 0;
  padding-left: 16px;
`;

const CommunityRow = styled(Row)`
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

const CommunityRowLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CommunityRowCount = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  opacity: 0.8;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  height: auto;
  background-color: ${colors.base.gamma};
  padding: 10px;
  gap: 0;
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 1;
  border-top: 1px solid ${colors.shades.gamma3};
`;

const EditingBar = styled.div`
  display: flex;
  align-items: center;
  background: ${colors.base.alpha};
  border: 1px solid ${colors.shades.gamma3};
  padding: 2px 6px;
  width: calc(100% - 16px);
  margin-bottom: 5px;
`;

const EditingText = styled.span`
  color: ${colors.shades.gamma14};
  font-size: 14px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 5px;
`;

const StyledCancelIcon = styled(Cancel)`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: auto;
`;

const StyledDialog = styled(DialogModal)`
  .MuiDialogContent-root {
    max-height: 95vh;
    overflow: hidden;
  }
`;

const EmptyCommentsContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: center;
`;

const CharacterCountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $isOverLimit }) => ($isOverLimit ? 'space-between' : 'flex-end')};
  margin-top: 5px;
  width: 100%;
`;

const CharacterCountText = styled.span`
  font-size: 14px;
  color: ${colors.shades.gamma14};
`;

const WarningText = styled.span`
  font-size: 14px;
  color: ${colors.base.danger};
`;

export {
  SectionLabel,
  RowList,
  CommentsRow,
  CommunityRail,
  CommentsColumn,
  CommunityRow,
  CommunityRowLabel,
  CommunityRowCount,
  AnnouncementContainer,
  PodFilterContainer,
  InputContainer,
  FullPostContainer,
  EditingBar,
  EditingText,
  StyledCancelIcon,
  CommentsContainer,
  StyledDialog,
  EmptyCommentsContainer,
  CharacterCountContainer,
  CharacterCountText,
  WarningText,
};
